import styles from './index.module.css'
import React from 'react'
import Counter from 'components/ui/counter'

type Props = {
  percentage?: number
  title: React.ReactNode
  value: React.ReactNode
  smallValueFont?: boolean
}

const Card = ({ percentage, title, value, smallValueFont }: Props) => (
  <div className={styles.Card}>
    <Counter
      caption={title}
      delta={percentage}
      value={value}
      smallValueFont={smallValueFont}
    />
  </div>
)

export default Card
